module.exports = __webpack_public_path__ + "img/saishianpai-icon-4.8c5d32f4.png";